import getPipeValue from './getPipeValue';

const isSpecialPlateAllowed = (pipe) => {
  if (!pipe) {
    return false;
  }
  // Special plates are not allowed if personal plates are
  // not allowed, and personal plates are not allowed when a
  // vehicle's pipestring value of r20 === 2.
  return Number(getPipeValue(pipe, 'r20')) !== 2;
};

export default isSpecialPlateAllowed;



// WEBPACK FOOTER //
// ./src/modules/isSpecialPlateAllowed.js